<template>
  <cTable
    :config="config"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #detail="{ params, visible }">
      <detail hq ref="detail" :rows="params" read v-if="visible"></detail>
    </template>
  </cTable>
</template>

<script>
import {
  getOtherFee,
  setBatchRate,
  recalculate,
  getMultiRate,
  del,
  add,
  getWherehouse,
  getDetails,
  update,
  uploadFile,
  getConfig,
  getFinance,
  saveFinance,
  getCharging,
  createBill
} from "@/api/finance/other_fee_hq";
import cTable from "@/base/common/index";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getExpense } from "@/api/finance/expense";
import { getService } from "@/api/double/list";
import { getCurrency } from "@/api/finance/currency";
import { getUser } from "@/api/user/internal";
import { getSelectType } from "@/api/public";
import { useModal } from "../b2b_bill_hq/rate.js";
import { getConfig as getConfig1 } from "@/api/double/bill_hq";
import detail from "../../order/miscellaneousQuotation/detail";
export default {
  name: "other_fee_hq",
  components: {
    cTable,
    detail
  },
  async mounted() {
    getConfig1().then(res => {
      this.$refs["table"].currency = res.data.payload.currency;
    });
    let client = (await getAllClient()).data.payload.rows;
    let expense_item = (await getExpense()).data.payload.rows;
    let ownershipList = (await getCompanies()).data.payload;
    this.defaultConfig = (await getConfig()).data.payload;
    this.defaultConfig.warehouse = this.defaultConfig.warehouse.map(t => ({
      value: t.id,
      label: t.title
    }));
    this.defaultConfig.transLocation = this.defaultConfig.transLocation.map(
      t => ({ value: t, label: t })
    );
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;

    this.header.searchs.forEach(item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "expense_item_id") item.options = expense_item;
      if (item.key === "creator_id") item.options = this.defaultConfig.creator;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "ownership") item.options = ownershipList;
    });
  },
  data() {
    return {
      init: false,
      defaultConfig: {},
      methods: {
        list: params => getOtherFee(Object.assign(params, { v: 2 })),
        del,
        getAllClient,
        getExpense,
        getWherehouse,
        add,
        getDetails,
        update,
        uploadFile,
        getMultiRate,
        getCurrency,
        setBatchRate,
        recalculate,
        getFinance,
        saveFinance,
        getCharging,
        createBill,
        beforeHandleList: ({ data }) => {
          console.log(data);
          if (!this.init && data.rows[0]) {
            this.init = true;
            let info = data.rows[0].financeInfo;
            let key = "financeInfo";
            this.fields.splice(
              this.fields.length - 3,
              0,
              ...Object.keys(info).map(t => {
                let item = info[t];
                let children = [];
                Object.keys(item.list).map(c => {
                  let child = item.list[c];
                  children.push({
                    name: child.current,
                    key: key + "." + t + ".list." + c + ".amount",
                    width: 95
                  });
                  this.config.hideVisible.push(
                    key + "." + t + ".list." + c + ".amount"
                  );
                });
                let field = {
                  name: item.name,
                  width: 95,
                  key: "trace",
                  key: key + "." + t,
                  children
                };
                return field;
              })
            );
            console.log(this.fields);
            this.$refs["table"].handleVisibleFields();
          }

          return data.rows.map(t => {
            t.mergeRow = t.numbers + t.bill_number + t.date_month;
            return t;
          });
        }
      },
      config: {
        hideVisible: [],
        mergeRows: [
          "checkbox",
          "clientInfo.client_account",
          "clientInfo.shipper_company_cn",
          "target_type_txt",
          "clientInfo.salesman_account",
          "clientInfo.ownership_name",
          "numbers",
          "finance_status_txt",
          "bill_number",
          // "create_time",
          "to_total_amount",
          "rateInfo.to_currency",
          ...["cny", "usd", "sar", "qar", "kwd"].map(
            t => "rateInfo." + t + "_to_rate"
          )
        ],
        mergeRow: "mergeRow"
      },
      modals: {
        detail: {
          footer: {
            show: () => false
          },
          contentSlot: "detail",
          config: {
            title: this.$t("bindFreight"),
            modalBind: {
              width: 70,
              top: "5%",
              draggable: true,
              sticky: true,
              styles: {
                top: "5%"
              }
            }
          }
        },
        rate: useModal.call(this, "b2b_details_hq"),
        createBill: {
          type: "add",
          methods: {
            ok: ({ row, close }) => {
              let data = JSON.parse(JSON.stringify(row));
              let table = this.$refs["table"];
              data.ids = table.selectAll.map(item => item.id);
              table
                .handleRequestMethods("createBill", data, true, true)
                .then(res => {
                  table.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur"
                }
              ],
              target_type: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        upload: {
          methods: {
            ok() {
              window.open(
                this.$globalUrl +
                  "/excel/tmp/MiscellaneousDetailsTpl.xlsx?" +
                  Math.random()
              );
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [
            {
              files: 24
            }
          ],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        },
        freight: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods("saveFinance", data, true, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            show() {
              return this.params.bill_id <= 0;
            }
          },
          config: {
            title: this.$t("bindFreight"),
            modalBind: {
              width: 800,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              charges_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              price: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              currency: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {
              expense_item_name: 24,
              charges_value: 24,
              charges_unit: 24,
              actual_weight: 24,
              volume: 24,
              price: 24,
              charges_type: 24,
              total_amount: 24,
              currency: 24,
              finance_time: 24,
              charge_status: 24
            }
          ],
          fields: [
            {
              name: this.$t("WhetherBilling"),
              key: "charge_status",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 }
              ],
              default: 1,
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Confirm Freight"),
              key: "finance_time",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" }
              ],
              default: "NO",
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("Expense Item"),
              key: "expense_item_name",
              component: "Input",
              placeholder: () => "",
              disabled: true
            },
            {
              name: () => this.$t("Number Charges"),
              key: "charges_value",
              component: "Input",
              placeholder: () => "",
              disabled: true
            },
            {
              name: () => this.$t("Charges Unit"),
              key: "charges_unit",
              component: "Input",
              placeholder: () => "",
              disabled: true
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "actual_weight",
              component: "Input",
              placeholder: () => "",
              disabled: true
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              placeholder: () => "",
              disabled: true
            },
            {
              name: () => this.$t("Charge Mode"),
              key: "charges_type",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("Charge Mode"),
              options: [],
              methods: {
                "on-change"({ row }) {
                  row.price &&
                    row.charges_type &&
                    this.$page
                      .handleRequestMethods("getCharging", {
                        price: row.price,
                        charges_type: row.charges_type,
                        id: row.id
                      })
                      .then(res => {
                        row.total_amount = res.payload;
                      });
                },
                list({ field }) {
                  field.options = this.$modal.params.charge_type_options;
                }
              }
            },
            {
              name: () => this.$t("billing_price"),
              key: "price",
              component: "InputNumber",
              bind: {
                style: "width:100%",
                parser: value => (value ? parseFloat(value).toFixed(2) : 0)
              },
              placeholder: () => this.$t("enter") + this.$t("billing_price"),
              default: 0,
              methods: {
                "on-blur"({ row }) {
                  row.price &&
                    row.charges_type &&
                    this.$page
                      .handleRequestMethods("getCharging", {
                        price: row.price,
                        charges_type: row.charges_type,
                        id: row.id
                      })
                      .then(res => {
                        row.total_amount = res.payload;
                      });
                }
              }
            },
            {
              name: () => this.$t("Charge Total Amount"),
              key: "total_amount",
              component: "Input",
              placeholder: () => this.$t("Charge Total Amount"),
              disabled: true
            },
            {
              name: this.$t("toCurrency"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code"
              },
              methods: {
                list({ field }) {
                  getCurrency().then(res => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                }
              }
            }
          ]
        },
        add: {
          footer: {
            show() {
              return ~~this.params.bill_id <= 0;
            }
          },
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 1200,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              expense_item_id: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              charges_value: [
                {
                  required: true,
                  trigger: "change"
                }
              ],
              charges_unit: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            {
              client_id: 6,
              expense_item_id: 6,
              charges_value: 6,
              charges_unit: 6,
              numbers: 6,
              batch_no: 6,
              actual_weight: 6,
              volume_weight: 6,
              warehouse: 6
            },
            {
              name: this.$t("Storage Charges"),
              children: [
                {
                  in_time: 8,
                  send_time: 8,
                  service_code: 8
                }
              ]
            },
            {
              name: this.$t("TransferFee"),
              children: [
                {
                  trans_time: 8,
                  trans_location: 8
                }
              ]
            },
            {
              remarks: 24
            }
          ],
          fields: [
            {
              name: () => this.$t("Number Charges"),
              key: "charges_value",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Number Charges")
            },
            {
              name: () => this.$t("Charges Unit"),
              key: "charges_unit",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("Charges Unit"),
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.unit;
                }
              }
            },
            {
              name: () => this.$t("batch_number"),
              key: "batch_no",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("batch_number")
            },
            {
              name: () => this.$t("inboundTime"),
              key: "in_time",
              placeholder: () => this.$t("enter") + this.$t("inboundTime"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                }
              }
            },
            {
              name: () => this.$t("Delivery Time"),
              key: "send_time",
              placeholder: () => this.$t("enter") + this.$t("Delivery Time"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                }
              }
            },
            {
              name: () => this.$t("Transit Time"),
              key: "trans_time",
              placeholder: () => this.$t("enter") + this.$t("Transit Time"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              },
              methods: {
                format({ value }) {
                  return ~~(new Date(value).getTime() / 1e3);
                }
              }
            },
            {
              name: () => this.$t("Delivery Type"),
              key: "service_code",
              placeholder() {
                return this.$t("select") + this.$t("Delivery Type");
              },
              component: "Select",
              options: [],
              config: {
                label: "service_name",
                value: "service_code"
              },
              methods: {
                async list({ field }) {
                  let res = (await getService()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("warehouse"),
              key: "warehouse",
              component: "Select",
              placeholder: () => this.$t("enter") + this.$t("warehouse"),
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.warehouse;
                }
              }
            },
            {
              name: () => this.$t("Transit Destination"),
              key: "trans_location",
              component: "Select",
              placeholder: () =>
                this.$t("enter") + this.$t("Transit Destination"),
              bind: {
                "allow-create": true
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.defaultConfig.transLocation;
                }
              }
            },
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("clientName"),
              config: {
                label: "account",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (await getAllClient()).data.payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("Expense Item"),
              key: "expense_item_id",
              component: "Select",
              placeholder: () => this.$t("Expense Item"),
              config: {
                label: "name",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (await getExpense()).data.payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("tracking order"),
              key: "numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("tracking order")
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "actual_weight",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("invoiceWeight")
            },
            {
              name: () => this.$t("square"),
              key: "volume_weight",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("square")
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("payment_description"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      footer: {
        show: () => true
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["MISCELLANEOUS_DATETYPE"])).data
                  .payload["MISCELLANEOUS_DATETYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            clearable: true,
            options: [
              { label: this.$t("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 }
            ]
          },

          {
            key: "is_finance",
            component: "Select",
            placeholder: () => this.$t("whetherFreight"),
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ]
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "expense_item_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("Expense Item");
            },
            clearable: true,
            options: [],
            config: { label: "name", value: "id" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 2
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 1261
            },
            {
              name: () => this.$t("batch") + this.$t("delete"),
              type: "delete",
              fnName: "batchDelete",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-trash"
              },
              id: 1260
            },
            {
              name: () => this.$t("export") + '成本',
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary"
              },
              list: [
                {
                  name: '单行数据',
                  type: "export",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: '合并数据',
                  type: "export",
                  fnName: "exportMerge",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
              ]
            },
            // {
            //   name: () => this.$t("export") + '应收',
            //   type: "export",
            //   fnName: "export2",
            //   bind: {
            //     icon: "md-arrow-down",
            //     type: "primary"
            //   }
            // },
            {
              name: () => this.$t("import"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary"
              },
              id: 1421
            },
            {
              name: () => this.$t("createBill"),
              type: "createBill",
              fnName: "createBill",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("batch") + this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("resAmount"),
              type: "resAmount",
              fnName: "resAmount",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            }
          ],
          methods: {
            createBill({ searchForm }) {
              this.getModal("createBill").open({
                ...searchForm,
                ids: this.selectAll.map(t => t.id),
                kids: this.selectAll.map(t => t.kid)
              });
            },
            import() {
              this.getModal("upload").open();
            },
            async export({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  ...searchForm,
                  export: 1,
                  ids: this.selectAll.map(t => t.id)
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            async exportMerge({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  ...searchForm,
                  export: 7,
                  ids: this.selectAll.map(t => t.id)
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            async export2({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  ...searchForm,
                  export: 9,
                  ids: this.selectAll.map(t => t.id)
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            add() {
              this.getModal("add").open();
            },
            batchDelete() {
              const data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("batch") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", data, true, true).then(
                    () => {
                      this.getList();
                    }
                  );
                }
              });
            },
            resAmount() {
              let data = this.selectAll.map(item => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("resAmount"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("recalculate", {
                    ids: data
                  }).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            rate({ row }) {
              let ids = this.selectAll.map(t => t.id);
              this.handleRequestMethods("getMultiRate", { ids }).then(res => {
                console.log(res, "res");
                let rules = {
                  USD: [],
                  CNY: [],
                  SAR: [],
                  AED: [],
                  QAR: [],
                  KWD: []
                };
                if (!Array.isArray(res.payload.curren_amount)) {
                  Object.keys(res.payload.curren_amount).map(
                    t =>
                      (rules[t] = [
                        {
                          required: true,
                          type: "number",
                          message: "cannot be empty",
                          trigger: "blur"
                        },
                        {
                          required: true,
                          type: "number",
                          message: "cannot less than 0.0001",
                          trigger: "blur",
                          min: 0.0001,
                          max: 999999
                        }
                      ])
                  );
                }
                Object.assign(this.modals.rate.config.rules || {}, rules);
                this.getModal("rate").open(
                  { ...res.payload.rate, ids, fn: "setBatchRate" },
                  function() {
                    this.setTitle(this.$t("batch") + this.$t("rate"));
                  }
                );
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          key: "checkbox",
          fixed: "left"
        },
        {
          name: () => this.$t("clientName"),
          key: "clientInfo.client_account",
          minWidth: 110
        },
        {
          name: () => this.$t("customerCompanyName"),
          key: "clientInfo.shipper_company_cn",
          minWidth: 110
        },
        {
          name: () => this.$t("CollectionUser"),
          key: "target_type_txt",
          width: 100
        },
        {
          name: () => this.$t("salesman"),
          key: "clientInfo.salesman_account",
          minWidth: 110
        },
        {
          name: () => this.$t("ownership"),
          key: "clientInfo.ownership_name",
          minWidth: 110
        },
        {
          name: () => this.$t("Odd_Numbers"),
          key: "numbers",
          minWidth: 110
        },
        {
          name: () => this.$tz("月份"),
          key: "date_month",
          minWidth: 110
        },
        {
          name: () => this.$tz("服务项目"),
          key: "service_code",
          minWidth: 110
        },
        {
          name: () => this.$t("appointmentNumber"),
          key: "base_data.reserve_number",
          minWidth: 110
        },
        {
          name: () => this.$t("Delivery Time"),
          key: "base_data.send_time",
          minWidth: 110
        },
        {
          name: () => this.$t("Delivery Type"),
          key: "base_data.service_code",
          minWidth: 110
        },
        {
          name: () => this.$t("warehouse"),
          key: "base_data.warehouse",
          minWidth: 110
        },
        {
          name: () => this.$t("batch_number"),
          key: "base_data.batch_no",
          minWidth: 110
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "base_data.actual_weight",
          minWidth: 110
        },
        {
          name: () => this.$t("square"),
          key: "base_data.volume",
          minWidth: 110
        },
        {
          name: () => this.$t("CTNS"),
          key: "base_data.piece_nums",
          minWidth: 110
        },
        {
          name: () => this.$t("PCS Count"),
          key: "base_data.pcs_nums",
          minWidth: 110
        },
        {
          name: () => this.$t("carton_nums"),
          key: "base_data.carton_nums",
          minWidth: 110
        },
        {
          name: () => this.$t("inboundTime"),
          key: "base_data.in_time",
          minWidth: 110
        },

        {
          name: () => this.$t("Stroage Days"),
          key: "base_data.storage_days",
          minWidth: 110
        },

        {
          name: () => this.$t("quantity1"),
          key: "base_data.charges_value",
          minWidth: 110
        },
        {
          name: () => this.$t("送仓仓库"),
          key: "base_data.target_warehouse",
          minWidth: 110
        },
        {
          name: () => this.$t("Transit Time"),
          key: "base_data.trans_time",
          minWidth: 110
        },
        {
          name: () => this.$t("Transit Destination"),
          key: "base_data.trans_location",
          minWidth: 110
        },
        {
          name: () => this.$t("price_t") + this.$t("Remarks"),
          key: "base_data.amount_remarks",
          minWidth: 110
        },
        {
          name: () => this.$t("service remark"),
          key: "base_data.kefu_remarks",
          minWidth: 200
        },
        {
          name: () => this.$t("whetherFreight"),
          key: "is_finance",
          minWidth: 110,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$tz("报价,备注"),
          key: "bj_remarks",
          minWidth: 110
        },
        {
          name: () => this.$t("SettlementStatus"),
          key: "finance_status_txt",
          minWidth: 110
        },
        // {
        // 	name: () => this.$t('offerer'),
        // 	key: 'finance_name',
        // 	minWidth: 110,
        // },
        // {
        // 	name: () => this.$t('QuotationConfirmTime'),
        // 	key: 'finance_time',
        // 	minWidth: 110,
        // },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          minWidth: 110,
          component: "a",
          methods: {
            click({ row }) {
              this.$page.toPage("other_fee_bill_hq", row.bill_number);
            }
          }
        },
        // {
        // 	name: () => this.$t('Remarks'),
        // 	key: 'remarks',
        // 	minWidth: 110,
        // },
        // {
        // 	name: () => this.$t('createUser'),
        // 	key: 'creator_name',
        // 	minWidth: 110,
        // },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 110
        },

        {
          name: () => this.$t("to") + this.$t("rate"),
          width: 110,
          children: ["to_currency", "cny", "usd", "sar", "qar", "kwd"].map(
            t => {
              let data = {
                name:
                  t === "to_currency" ? this.$t("toCurrency") : t.toUpperCase(),
                key: "rateInfo." + (t === "to_currency" ? t : t + "_to_rate"),
                width: 95
              };
              return data;
            }
          )
        },
        {
          name: () => this.$t("total"),
          key: "to_total_amount",
          minWidth: 110,
          fixed: "right"
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 1262
            },
            {
              name: this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              bind: {
                type: "success"
              }
            }
          ],
          methods: {
            freight({ row }) {
              let ids = this.list
                .filter(t => t.numbers === row.numbers)
                .map(t => t.master_id);
              row.master_id = [].concat(...ids);
              this.getModal("detail").open(row);
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                if (!res.payload.ship_time) res.payload.ship_time = "";
                else
                  res.payload.ship_time = new Date(
                    res.payload.ship_time * 1000
                  );
                this.getModal("add").open(res.payload, function() {
                  this.config.formBind.disabled = res.payload.bill_id > 0;
                  this.setTitle(this.$t("update"));
                });
              });
            }
          }
        }
      ]
    };
  }
};
</script>
